import { createImplementation } from './connectorApi';
import {
    buildCreateImplementationPayload,
    mapCreateImplementationError,
} from './mapCreateImplementation';
import { pollImplementationStatus } from './pollImplementationStatus';
import { resolveSessionCache } from './refreshSessionCache';
import { SYNC_ERROR_CODES } from './constants';

export const runSyncFlow = async (selectedCompanyIds, { sessionId, onPhase } = {}) => {
    const resolved = await resolveSessionCache(sessionId);

    if (resolved.needsSageIdLogin) {
        return { needsSageIdLogin: true };
    }

    if (!resolved.success) {
        return {
            success: false,
            errorCode: resolved.errorCode ?? SYNC_ERROR_CODES.SESSION_CACHE_EMPTY,
        };
    }

    const cache = resolved.cache;
    const payload = buildCreateImplementationPayload(cache, selectedCompanyIds);

    if (!payload.email?.trim() || !payload.companyName?.trim()) {
        return { success: false, errorCode: SYNC_ERROR_CODES.MISSING_SESSION_FIELDS };
    }

    if (!payload.siteIds.length) {
        return { success: false, errorCode: SYNC_ERROR_CODES.CREATE_FAILED };
    }

    try {
        onPhase?.('creating');

        const { data } = await createImplementation(payload);
        const tag = data?.tag;

        if (!tag) {
            return { success: false, errorCode: SYNC_ERROR_CODES.CREATE_FAILED };
        }

        onPhase?.('polling');

        const pollResult = await pollImplementationStatus(tag);

        if (pollResult.needsSageIdLogin) {
            return pollResult;
        }

        if (!pollResult.success) {
            return {
                success: false,
                errorCode: pollResult.errorCode ?? SYNC_ERROR_CODES.CREATE_FAILED,
            };
        }

        onPhase?.('complete');

        return { success: true, redirectUrl: pollResult.redirectUrl };
    } catch (error) {
        return mapCreateImplementationError(error);
    }
};
